<template>
<b-form-group>
    <b-input-group class="mb-3">
      <b-input-group-prepend>
        <b-input-group-text>
          <i style="font-size:18px" class="fa">&#xf002;</i>
        </b-input-group-text>
      </b-input-group-prepend>
      <b-form-input
        v-model="query"
        type="text"
        placeholder="Search..."
        @input="$emit('input', query.trim())"
      ></b-form-input>
    </b-input-group>
</b-form-group>
</template>

<script>
export default {
  name: 'SearchInput',

  data() {
    return {
      query: '',
    };
  },
};
</script>
